import { VOLUME_CALCULATION_VIEW } from '@/fixtures'

export default {
  path: 'summary-volume-calculation',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Perhitungan Bersama',
      component: () => import('@/views/menus/SummaryVolumeCalculation/Index'),
      meta: {
        permission: VOLUME_CALCULATION_VIEW
      }
    },
    {
      path: ':id/detail',
      name: 'Detail Perhitungan Bersama',
      component: () => import('@/views/menus/SummaryVolumeCalculation/View'),
      meta: {
        permission: VOLUME_CALCULATION_VIEW
      }
    }
  ]
}
